import type { Schemas } from '@beamx/shared';
import { request } from './client.js';

// Types derive from the backend OpenAPI contract (generated schema.d.ts).
export type SenderDomainStatus = Schemas['SenderDomainStatus'];
export type RequiredDnsRecord = Schemas['RequiredDnsRecord'];
export type SenderDomainSummary = Schemas['SenderDomainSummary'];

export const senderDomains = {
  list: () => request<SenderDomainSummary[]>('/v1/sender-domains'),

  get: (id: string) => request<SenderDomainSummary>(`/v1/sender-domains/${id}`),

  register: (domain: string, dkimSelector?: string) =>
    request<SenderDomainSummary>('/v1/sender-domains', {
      method: 'POST',
      body: { domain, dkimSelector: dkimSelector ?? null },
    }),

  verify: (id: string) =>
    request<SenderDomainSummary>(`/v1/sender-domains/${id}/verify`, { method: 'POST' }),

  rotateDkim: (id: string) =>
    request<SenderDomainSummary>(`/v1/sender-domains/${id}/rotate-dkim`, { method: 'POST', body: {} }),
};
